export const getCarrierLabel = (carrier) => {
    if (carrier === "Vodafone klarmobil") {
        return "D-Netz";
    }
    if (carrier === "Telekom klarmobil") {
        return "D-Netz";
    }
    return carrier;
};
